import {
  AdminOrgScope,
  OrgCombobox,
  type SelectedOrg,
} from '@/features/admin-terminal';
import { PremiumMusicDirectory } from '@/features/music/components/premium-music-directory';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
export const Route = createFileRoute('/_admin/admin/music')({
  component: AdminMusicPage,
});
function AdminMusicPage() {
  const [org, setOrg] = useState<SelectedOrg | null>(null);
  return (
    <div className="container max-w-6xl space-y-6 py-8">
      <title>Music directory | Borrah</title>
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">
          Music directory
        </h1>
        <p className="mt-2 text-muted-foreground">
          Find the soundtrack for a premium ad. Search and audition the
          catalogue Claire uses.
        </p>
      </div>
      <OrgCombobox value={org} onChange={setOrg} />
      {org ? (
        <AdminOrgScope organizationId={org.id}>
          <PremiumMusicDirectory />
        </AdminOrgScope>
      ) : (
        <p className="text-sm text-muted-foreground">
          Select an organization to browse its music.
        </p>
      )}
    </div>
  );
}
